import { render, staticRenderFns } from "./Reporting.vue?vue&type=template&id=0c5d7ef0&scoped=true&"
import script from "./Reporting.vue?vue&type=script&lang=js&"
export * from "./Reporting.vue?vue&type=script&lang=js&"
import style0 from "./Reporting.vue?vue&type=style&index=0&id=0c5d7ef0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5d7ef0",
  null
  
)

export default component.exports